import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { container, item, inView } from "../service/presets";

export default function CTABand() {
  const { t, dir, lang } = useLang();
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";
  return (
    <section className="rq-dark py-16 relative overflow-hidden">
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-[360px] w-[360px] rounded-full blur-[120px] opacity-30" style={{ background: "radial-gradient(circle,#14a24b,transparent 70%)" }} />
      <div className="rq-container relative z-10">
        <motion.div {...inView} variants={container} className="max-w-2xl mx-auto text-center">
          <motion.h2 variants={item} className="font-display text-3xl md:text-4xl font-bold text-white leading-tight">{t.ctaSection.title}</motion.h2>
          <motion.p variants={item} className="mt-5 text-[15px] md:text-lg text-[color:var(--rq-muted)] leading-relaxed">{t.ctaSection.desc}</motion.p>
          <motion.div variants={item} className="mt-8 flex justify-center">
            <Link to="/contact" className="rq-glow-btn inline-flex items-center gap-2 px-8 py-4" data-testid="resource-cta-contact">
              {lang === "ar" ? "تواصل مع فريقنا" : "Talk to Our Team"}
              <ArrowRight size={18} style={{ transform: flip }} />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
